
export class AutoTestTokenSubmit {
  visitorId: string | null | undefined;
  testId: string | null | undefined;
  email: string | null | undefined;
}
